<template>
  <div class="flex flex-col items-center justify-center text-center p-6">
    <div class="p-6">
      <div class="w-12 h-12 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
    </div>
    <h2 class="text-base font-medium text-gray-400">{{ loadingText }}</h2>

  </div>
</template>

<script setup>
import { computed } from 'vue'
const props = defineProps({
  state: {
    type: String,
    default: 'generic',
  }
})

const loadingText = computed(() => {
  switch (props.state) {
    case 'initial':
      return 'Daten werden geladen ...'
    case 'formSubmit':
      return 'Anfrage wird gesendet ...'
    default:
      return 'Bitte warten …'
  }
})
</script>